import styled from 'styled-components';
import Select from 'react-select';
import { keyframes } from 'styled-components';
import { Box } from '@chakra-ui/react';

const SkeletonLoading = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const SelectStyled = styled(Select)`
  //componente com altura maxima de 29 px
  //componente com borda de 0
  //aumenta o width do optionsc-gMVCMe fyvRDy css-b62m3t-container
  //sc-gMVCMe fyvRDy css-b62m3t-container

  .css-26l3qy-menu {
    border: 0;
    width: ${(props) => (props.width ? props.width : '100%')};
    background-color: #f5f5f5 !important;
  }

  svg {
    color: #378bbf;
    /* transform: rotate(90deg); */
  }

  //define o bgColor do option
  #react-select-3-option-0 {
    background-color: #f5f5f5;
  }
`;

export const Skeleton = styled(Box)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background: ${(props) =>
    props.background
      ? `linear-gradient(90deg, ${props.background} 25%, #4ea9e2 50%, ${props.background} 75%)`
      : 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)'};
  background-size: 200% 100%;
  animation: ${SkeletonLoading} 1.5s infinite;

  /* background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%); */
`;
